export default "__VITE_ASSET__8p5aG0bt__"